import { FunctionComponent, JSX } from 'react'
import styles from './ButtonIcon.module.scss'
import { Badge } from '@mui/material'

interface ButtonTextIconTemplateProps {
    icon: JSX.Element
    onClick?: () => void
    parent?: boolean
    className?: string
    badge?: number
    disabled?: boolean
}

const ButtonIcon: FunctionComponent<ButtonTextIconTemplateProps> = ({
    icon,
    onClick,
    parent,
    className,
    badge,
    disabled
}: ButtonTextIconTemplateProps) => {
    return (
        <button
            className={`${styles.button} ${className} 
			${
                disabled
                    ? parent
                        ? styles.buttonParentDisabled
                        : styles.buttonDaycareDisabled
                    : parent
                      ? styles.buttonParent
                      : styles.buttonDaycare
            }`}
            onClick={onClick}
            disabled={disabled}
        >
            {badge ? (
                <Badge badgeContent={badge} className={parent ? styles.badgeParent : styles.badgeDaycare}>
                    {icon}
                </Badge>
            ) : (
                <>{icon}</>
            )}
        </button>
    )
}

export default ButtonIcon
